import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Copy, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

interface ApiKeyDialogProps {
  apiKey: string | null;
  open: boolean;
  onClose: () => void;
}

export const ApiKeyDialog = ({ apiKey, open, onClose }: ApiKeyDialogProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!apiKey || copied) return;
    try {
      await navigator.clipboard.writeText(apiKey);
      setCopied(true);
      toast.success("Clé API copiée dans le presse-papiers", {
        style: { color: "#228B22" },
      });
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Échec de la copie de la clé API");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-125">
        <DialogHeader>
          <DialogTitle>Clé API générée</DialogTitle>
          <DialogDescription className="text-destructive font-medium">
            Cette clé ne sera affichée qu'une seule fois. Copiez-la maintenant et conservez-la en lieu sûr.
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center gap-2 py-4">
          <Input readOnly value={apiKey ?? ""} className="font-mono text-sm" />
          <Button type="button" variant="outline" size="icon" onClick={handleCopy} className="shrink-0">
            {copied ? <Check className="h-4 w-4 text-green-600" /> : <Copy className="h-4 w-4" />}
          </Button>
        </div>
        <DialogFooter>
          <Button onClick={onClose}>Fermer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
